/**
 * @file Upgrade Eligibility
 */

/**
 * Upgrade Eligibility component
 */
const vUpgradeEligibility = () => {
	const upgradeEligibility = document.querySelector( '.v-upgrade-eligibility' );

	if ( ! upgradeEligibility ) {
		return;
	}

	const form = upgradeEligibility.querySelector( '.wpcf7' );
	form.addEventListener( 'wpcf7mailsent', ( e ) => {
		const volume = e.detail.formData.get( 'report-volume' );
		if ( volume === '1-250' ) {
			window.location = 'https://app.prod.selfsvc.platform.creditxpert.com/preselect-plan';
		} else {
			window.location = 'https://creditxpert.com/get-started/?utm_campaign=Enterprise&utm_source=website&utm_medium=upgradefaq&utm_term=website&utm_content=enterprise';
		}
	} );
};

export default vUpgradeEligibility;
